/**
 * 主站前台 - 功能介绍（系列文章索引页）
 * 路由: /features
 * 12篇静态系列文章，卡片布局
 */
import { Link } from 'react-router-dom';
import { GUIDE_ARTICLES } from './guideData';

export default function FeaturesPage() {
  return (
    <div style={{ minHeight: '100vh', paddingTop: '80px', paddingBottom: '80px' }}>
      {/* Hero */}
      <div style={{ textAlign: 'center', padding: '60px 20px 50px', maxWidth: '800px', margin: '0 auto' }}>
        <div style={{ fontSize: '14px', letterSpacing: '4px', textTransform: 'uppercase', color: '#60a5fa', marginBottom: '16px', fontWeight: 600 }}>
          NCB · 功能介绍
        </div>
        <h1 style={{ fontSize: 'clamp(28px, 5vw, 48px)', fontWeight: 800, lineHeight: 1.2, marginBottom: '20px' }}>
          <span style={{ background: 'linear-gradient(135deg, #60a5fa, #a78bfa, #f472b6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            产品经理的完备建站工具箱
          </span>
        </h1>
        <p style={{ fontSize: '18px', color: '#94a3b8', lineHeight: 1.8, maxWidth: '600px', margin: '0 auto' }}>
          前端自由设计，后端复杂数据逻辑。
          12 篇系列文章，带你全面了解 NCB 的每一项能力。
        </p>
      </div>

      {/* Article Grid */}
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 20px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          gap: '24px',
        }}>
          {GUIDE_ARTICLES.map((article, idx) => (
            <Link
              key={article.id}
              to={'/features/' + article.slug}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div style={{
                background: 'linear-gradient(145deg, rgba(30,41,59,0.8), rgba(15,23,42,0.9))',
                border: '1px solid rgba(71,85,105,0.4)',
                borderRadius: '16px',
                padding: '28px',
                height: '100%',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = '#3b82f6';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(59,130,246,0.15)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = 'rgba(71,85,105,0.4)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              >
                {/* 序号标记 */}
                <div style={{
                  position: 'absolute', top: '16px', right: '16px',
                  fontSize: '48px', fontWeight: 900, color: 'rgba(59,130,246,0.08)',
                  lineHeight: 1, userSelect: 'none',
                }}>
                  {String(idx + 1).padStart(2, '0')}
                </div>

                <div style={{ fontSize: '36px', marginBottom: '16px' }}>{article.icon}</div>
                <div style={{ fontSize: '12px', color: '#60a5fa', fontWeight: 600, marginBottom: '8px', letterSpacing: '1px' }}>
                  第 {article.id} 篇 · {article.readTime}阅读
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#f1f5f9', marginBottom: '10px', lineHeight: 1.4 }}>
                  {article.title}
                </h3>
                <p style={{ fontSize: '14px', color: '#94a3b8', lineHeight: 1.6, margin: 0 }}>
                  {article.subtitle}
                </p>
                <div style={{ marginTop: '16px', fontSize: '13px', color: '#3b82f6', fontWeight: 500 }}>
                  阅读文章 →
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div style={{ textAlign: 'center', marginTop: '80px', padding: '0 20px' }}>
        <p style={{ fontSize: '16px', color: '#64748b', marginBottom: '24px' }}>
          了解完 NCB 的能力后，立即开始构建你的第一个网站
        </p>
        <a
          href="/register"
          style={{
            display: 'inline-block', padding: '14px 40px',
            background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
            color: '#fff', borderRadius: '10px', fontSize: '16px', fontWeight: 600,
            textDecoration: 'none', transition: 'all 0.3s',
          }}
        >
          免费注册体验
        </a>
      </div>
    </div>
  );
}
